import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import Fav from '@/images/favicon.ico'
import { isBrowser } from '@/lib/utils'
import ReactGA from 'react-ga';
import { Helmet } from 'react-helmet'

function SEO(props: any) {
  const { description, keywords, title } = props || {}
  
  useEffect(() => {
    if (!isBrowser) { return }
    ReactGA.initialize('UA-143184118-1', { gaAddress: 'https://baleen-cdn-g.bieyangapp.com/by/external/ga/analytics.js' });
    ReactGA.pageview(window.location.pathname + window.location.search);

    var _hmt: any = _hmt || [];
    (function () {
      let scripts = document.querySelectorAll('script')
      let has = Array.from(scripts).find(item => {
        return item.id === 'hm_baidu'
      })
      if (!has) {
        const hm = document.createElement("script");
        hm.id = 'hm_baidu'
        hm.src = "https://hm.baidu.com/hm.js?88822043d36cef4449b659deb55659a3";
        const s = document.getElementsByTagName("script")[0];
        s?.parentNode?.insertBefore(hm, s);
      }
    })();
  }, [])
  return (
    <React.Fragment>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        {/* <meta name="image" content={image} /> */}
        <link rel="canonical" type='image/x-icon' href={Fav} />
        <link rel="shortcut icon" type='image/x-icon' href={Fav} />
        <meta name='keywords' content={keywords}></meta>
        <meta name='google-site-verification' content={'_JB8ytuqVrvViJAczGvWLMwXTgrgx4O7i5cRSY8O9To'}></meta>
        <meta name='baidu-site-verification' content={'code-s7H5z2bDV5'}></meta>
      </Helmet>
    </React.Fragment>
  )
}

SEO.propTypes = {
  description: PropTypes.string,
  keywords: PropTypes.string,
  title: PropTypes.string.isRequired,
}

export default SEO